import React from 'react';

export default function RainbowBanner() {
  return (
    <div className="rainbow-banner">
      <div className="harper-yellow" />
      <div className="paco-blue" />
      <div className="amelia-orange" />
      <div className="philo-green" />
      <div className="ruby-violet" />
      <div className="lamar-red" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/features/layout/components/RainbowBanner.js